module.exports = __webpack_public_path__ + "img/PCT10.6dae929e.svg";